import React from 'react';
import { View } from 'react-native';
import HeimeText from './HeimeText';
import Icon from './Icon/Icon';
import { smallestMargin, smallestFontSize, smallestMarginPixels } from '../_utils/sizes';
import { useThemeContext } from '../_utils/themeContext';

const Tip = ({ title, description }: { title: string; description: string }) => {
    const { theme } = useThemeContext();
    return (
        <View style={{ flexDirection: 'row', gap: smallestMargin }}>
            <Icon name="checkboxCircle" color="main" />
            <View style={{ flex: 1 }}>
                <HeimeText
                    style={{
                        fontWeight: 'bold',
                        color: theme.main,
                        fontSize: smallestFontSize,
                        marginBottom: smallestMargin,
                    }}
                >
                    {title}
                </HeimeText>
                <HeimeText
                    style={{
                        color: theme.darkGray,
                        fontSize: smallestFontSize,
                        marginBottom: smallestMarginPixels,
                    }}
                >
                    {description}
                </HeimeText>
            </View>
        </View>
    );
};

export default Tip;
